<div class="min-h-full">
    <div class="sticky left-0 top-0 z-50 bg-purple-200 flex items-center gap-2">
        <img
            class="size-20"
            [src]="offerStore.offer()?.logoUrl"
            alt="" />
        <span class="text-5xl font-bold">{{ offerStore.offer()?.id }} - {{ offerStore.offer()?.title }}</span>
    </div>
    <mat-tab-group>
        <mat-tab label="Goals">
            <ng-template matTabContent>
                <app-offer-goals></app-offer-goals>
            </ng-template>
        </mat-tab>
        <mat-tab label="Challenges">
            <ng-template matTabContent>
                <app-offer-challenges></app-offer-challenges>
            </ng-template>
        </mat-tab>
    </mat-tab-group>
</div>
